export interface StatusOption {
  id: number;
  label: string;
  colorClass: string;
}

export const FLAG_MANAGER_STATUSES: StatusOption[] = [
  { id: 1, label: 'Prepare Flags for Rec Letter', colorClass: 'red' },
  { id: 2, label: 'Flags Preparation in Progress', colorClass: 'orange' },
  { id: 3, label: 'Rec Letter Sent', colorClass: 'light-yellow' },
  { id: 4, label: 'Resolution in Progress', colorClass: 'green' },
  { id: 5, label: 'Closed', colorClass: 'blue' },
];

export enum UnlinkAllOption {
  KEEP,
  CLEAR,
  CANCEL,
}
